import { z } from "zod"

import { SETTINGS_SCOPE } from "@tfg/types/constants/communication-studio.constant"
import {
  LanguagePermissionLevelEnum,
  PermissionLevelEnum,
} from "@tfg/types/endpoints/subscriptionPlan"
import { ComponentTypesEnum } from "@tfg/types/types/communication-studio/components.types"

const LanguagePermissionSchema = z.object({
  level: z.enum(LanguagePermissionLevelEnum),
  description: z.string().optional(),
})

const GenericPermissionSchema = z.object({
  level: z.enum(PermissionLevelEnum),
  description: z.string().optional(),
})

const ProductPageComponentsPermissionSchema = z.object({
  level: z.enum(PermissionLevelEnum),
  description: z.string().optional(),
  components: z.array(z.enum(ComponentTypesEnum)),
})

const DesignCustomisationPermissionSchema = z.object({
  level: z.enum(PermissionLevelEnum),
  description: z.string().optional(),
  authorizedDesignTokens: z.object({
    stylingParameters: z.record(z.string(), z.record(z.string(), z.boolean())),
    configurations: z.record(z.string(), z.record(z.string(), z.boolean())),
  }),
})

export const PermissionsPerScopeSchema = z.object({
  [SETTINGS_SCOPE.LANGUAGES]: LanguagePermissionSchema,
  [SETTINGS_SCOPE.DESIGN_CUSTOMISATION]: DesignCustomisationPermissionSchema,
  [SETTINGS_SCOPE.COMPONENT_CUSTOMISATION]: GenericPermissionSchema,
  [SETTINGS_SCOPE.CONTENT_FILTERING]: GenericPermissionSchema,
  [SETTINGS_SCOPE.PRODUCT_PAGE_COMPONENTS]:
    ProductPageComponentsPermissionSchema,
})
